import { Grid, Skeleton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../custom-hooks/redux/redux";
import { MailInboxSummaryDTO } from "../../../../models/mail-inbox-summary/mail-inbox-summary-dto";
import { AUTHORIZATIONS } from "../../../../utils/constants/authorization-constants";

const ReadableOutgoingMailLink = ({
  customSummary,
  loading,
}: {
  customSummary: MailInboxSummaryDTO;
  loading: boolean;
}) => {
  const { t } = useTranslation();
  const tRP = "components.custom_widget_links.manage_mail";
  const theme = useTheme();

  const { currentUserAuthorizations } = useAppSelector((state) => state.currentUserReducer);
  const mailInboxAuth = currentUserAuthorizations?.allowedMailInboxes?.flatMap(
    (allowedMailInbox) => allowedMailInbox.value
  );

  const hasOnlyAccessToRead =
    (!currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanUploadIncoming) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanClassifyIncoming) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanClassifyOutgoing) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanProcessOutgoing) &&
      !currentUserAuthorizations?.allowedDomains.includes(AUTHORIZATIONS.MailInboxAccess.CanUploadOutgoing) &&
      (mailInboxAuth?.includes(AUTHORIZATIONS.MailInboxAccess.CanReadIncoming) ||
        mailInboxAuth?.includes(AUTHORIZATIONS.MailInboxAccess.CanReadOutgoing))) ??
    false;

  const canReadOutgoing = mailInboxAuth?.includes(AUTHORIZATIONS.MailInboxAccess.CanReadOutgoing);

  return (
    <Grid
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "5px",
        width: "100%",
        marginBottom: "2px",
      }}
    >
      {loading ? (
        <Skeleton
          variant="rounded"
          width={"70%"}
        />
      ) : (
        hasOnlyAccessToRead &&
        canReadOutgoing &&
        !!customSummary?.totalReadableOutgoing &&
        customSummary.totalReadableOutgoing > 0 && (
          <Grid
            style={{
              display: "flex",
              color: theme.palette.primary.main,
              justifyContent: "center",
              alignItems: "end",
              gap: "5px",
              width: "150px",
              margin: "3px 0px",
            }}
          >
            <Typography style={{ fontSize: "25px", color: theme.palette.primary.main }}>
              {customSummary.totalReadableOutgoing}
            </Typography>
            <Typography style={{ fontSize: "25px", color: theme.palette.text.primary }}>
              {`${t(`${tRP}.outgoing`)}`}
            </Typography>
          </Grid>
        )
      )}
    </Grid>
  );
};
export default ReadableOutgoingMailLink;
